import Vue from "vue";

export function removeElementFromArray(array, element) {
  if (element === null || element === undefined) {
    return;
  }

  for (let i = 0; i < array.length; i++) {
    if (array[i] === element) {
      array.splice(i, 1);
      return true;
    }
  }
  return false;
}

export function moveInArray(arr, old_index, new_index) {
  while (old_index < 0) {
    old_index += arr.length;
  }
  while (new_index < 0) {
    new_index += arr.length;
  }
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing purposes
}

export function swap(arr, index1, index2) {
  const temp = arr[index1];
  arr[index1] = arr[index2];
  arr[index2] = temp;
}

export function vueSwap(arr, x, y) {
  const origin = arr[x];
  arr[x] = arr[y];
  Vue.set(arr, y, origin);
}

export function indexOf(array, predicate) {
  for (let i = 0; i < array.length; i++) {
    const isMatch = predicate(array[i]);
    if (isMatch) {
      return i;
    }
  }

  return -1;
}

export function any(array, predicate) {
  for (let i = 0; i < array.length; i++) {
    const isMatch = predicate(array[i]);
    if (isMatch) {
      return true;
    }
  }

  return false;
}

export function firstOrDefault(array, predicate) {
  for (let i = 0; i < array.length; i++) {
    const isMatch = predicate(array[i]);
    if (isMatch) {
      return array[i];
    }
  }

  return null;
}

export function lastOrDefault(array) {
  if (!array || !array.length) return null;

  return array[array.length - 1];
}
